import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { MainContextProvider } from './context/MainContext';
import { Provider } from 'react-redux';
import { store } from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MainContextProvider>
        <RouterProvider router={router} />
      </MainContextProvider>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
